export class LoggedInUserSettingsBase {
  public user_id: string;
  public practice_id: string;
  public show_task_reminders_promo: boolean;
}
